import React from 'react';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";
import Button from '@material-ui/core/Button';
import { Grid } from 'semantic-ui-react';
import CircularProgress from '@material-ui/core/CircularProgress';

class Title extends React.Component {

  state = {
    load: false,
    message: ''
  }

  delete() {
    let context = this;
    let id = this.props.deleteId;
    let data1 = { 'id': id }
    this.setState({
      load: true,
      message: 'Deleting Part Alias Name!!!!',
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/deletealias.php',
      success: function(data)
      {
        context.setState({ load: false })
        console.log(data);
        if (data == 1) {
          context.props.getBrandById();
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    const { load, message } = this.state;
    return (
      <div>
      <Grid>
        <Loading load={load} message={message} />
        <Grid.Column mobile={16} tablet={16} computer={16}>
          Do you want to remove it!!!
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <center><Button onClick={ () => { this.props.handleClose(); }}>cancel</Button></center>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          {load ?
            (<div><center><CircularProgress size={18} color='secoundary' /></center></div>)
           :
            (<div><center><Button onClick={this.delete.bind(this)}>Yes</Button></center></div>)
          }
        </Grid.Column>
      </Grid>
    </div>
    );
  }
}

export default Title;
